import React from 'react';
import { IPaymentTenderType } from './paymentContext';

interface IPaymentSelectorButton {
    paymentTenderType: IPaymentTenderType;
    onTenderTypeSelect: (tenderType: IPaymentTenderType) => void;
    disabled: boolean;
}

export const PaymentSelectorButton: React.FC<IPaymentSelectorButton> = ({ paymentTenderType, onTenderTypeSelect, disabled }) => {
    const handleTenderTypeSelect = () => onTenderTypeSelect(paymentTenderType);

    return (
        <button
            className={`payment-selector__button-container--on-account msc-btn btn-primary ${disabled ? 'disabled' : ''}`}
            onClick={handleTenderTypeSelect}
            disabled={disabled}
        >
            {paymentTenderType.tenderName}
        </button>
    );
};
